const styles = (theme) => ({
  paper: {
    width: '514px',
    height: 'auto',
  },
  title: {
    color: '#fff',
    height: '88px',
    backgroundColor: '#2B596F',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 700,
    fontSize: '24px',
    padding: '24px',
  },
  content: {
    paddingTop: theme.spacing(6),
    fontSize: '16px',
    '& > div': {
      marginBottom: theme.spacing(1)
    }
  },
  actions: {
    justifyContent: 'center',
    paddingBottom: theme.spacing(6),
  },
  input: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#2B596F',
      },
      '&:hover fieldset': {
        borderColor: '#2B596F',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#2B596F',
      },
    },
  },
  customLabel: {
    color: '#000000',
    fontWeight: '700',
    marginBottom: theme.spacing(1),
    fontSize: '16px',
    fontStyle: 'normal',
    lineHeight: 'normal',
  },
  widerInput: {
    width: '100%',
    marginBottom: theme.spacing(2),
    '& .MuiInput-underline:before': {
      borderBottomColor: '#2B596F',
    },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: '#2B596F',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#2B596F',
    },
  },
});

export default styles;